<template>
    <div class="col-md-12">
        <div class="card">
            <div class="card-header">
                <h4 class="float-left">Versandkosten Kalk</h4>
                <b-button
                    @click="createItem()"
                    variant="secondary"
                    class="btn-md ml-2 float-right"
                ><!-- button -->
                    <span class="icon icon-plus"></span>
                </b-button>
                <b-form-select
                    id="selectCountry"
                    v-model="selectedCountry"
                    :options="countries"
                    :disabled="pendingChanges"
                    @change="loadItems()"
                    class="float-right col-md-4"
                ></b-form-select>
            </div>
            <div class="card-body">
                <b-overlay :show="queryInProgress" rounded="sm">
                    <table class="table-editable table table-hover">
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <th>Gewichtsobergrenze (Mat +30%/300g)</th>
                                <th>Maße</th>
                                <th>Stückpreis</th>
                                <th>Kilopreis</th>
                                <th>RFID</th>
                                <th>Volumengewicht</th>
                                <th>Actions</th>
                            </tr>
                            <tr v-for="(item, idx) in items" v-bind:key="idx">
                                <td>
                                    <input type="text" class="form-control" required v-model="item.name">
                                </td>
                                <td>
                                    <div class="input-group">
                                        <input type="text" class="form-control" required v-model="item.upToWeight">
                                        <div class="input-group-append mb-auto"><span class="input-group-text">g</span></div>
                                    </div>
                                </td>
                                <td>
                                    <b-form-select id="inputMdFlagSet" v-model="item.mdFlagSet" :options="mdFlagsNew"></b-form-select>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <input type="text" class="form-control" required v-model="item.fixedRate">
                                        <div class="input-group-append mb-auto"><span class="input-group-text">€</span></div>
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <input type="text" class="form-control" required v-model="item.perKilo">
                                        <div class="input-group-append mb-auto"><span class="input-group-text">€/kg</span></div>
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group">
                                        <input type="text" class="form-control" required v-model="item.rfid">
                                        <div class="input-group-append mb-auto"><span class="input-group-text">€</span></div>
                                    </div>
                                </td>
                                <td>
                                    <input type="checkbox" class="form-control" value="1" required v-model="item.useVolumeWeight" :true-value="1" :false-value="0">
                                </td>
                                <td>
                                    <button type="button" class="btn btn-secondary btn-md" @click="deleteItem(idx)">
                                        <span class="icon icon-bin"></span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <b-button
                        @click="createItem()"
                        variant="secondary"
                        class="float-right mr-3"
                    ><!-- button -->
                        <span class="icon icon-plus"/>
                    </b-button>
                    <b-button @click="save()" class="float-right mr-2">Speichern</b-button>
                </b-overlay>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['passedCountries'],
        data() {
            return {
                items: [],
                mdFlagsNew: [
                   { text: "-", value: 0 },
                   { text: "Brief", value: 67108864 },
                   { text: "Warenpost DE", value: 134217728 },
                   { text: "Warenpost Int.", value: 268435456 },
                   { text: "Spring Brief", value: 536870912 },
                   { text: "Spring Boxable", value: 1073741824 },
                   { text: "PostNL Letterbox Plus", value: 131072 },
									 { text: "DHL Kleinpaket", value: 2 },
									 { text: "Spring Paket US", value: 2048 },
                ],
                nextSortValue: 0,
                countries: this.passedCountries,
                selectedCountry: 1,
                queryInProgress: false,
                customSpinnerDeg:0,
                pendingChanges: false,
                alertSaveSwitch: false
            }
        },
        watch: {
            selectedCountry: function(val, oldVal) {
                this.loadItems();
            },
            items: {
				handler: function(nv, ov) {
					this.pendingChanges = true;
				},
				deep: true
			}
        },
        methods: {
            loadItems() {
                this.queryInProgress = true;
                axios.get(`/shippingfeerule/items/${this.selectedCountry}`).then((response) => {
                    this.items = response.data;
                    this.nextSortValue = 0;
                    this.queryInProgress = false;
                    for(let item in this.items)
                    {
                        if(this.items[item].sort >= this.nextSortValue)
                        {
                            this.nextSortValue = this.items[item].sort+1;
                        }
                    }
                    if(!this.alertSaveSwitch)
                    {
                        this.$bvToast.toast(
                            "Daten wurden erfolgreich geladen."
                            , {
                                title: "Shipping Fee Rule Editor"
                                , appendToast: false
                                , variant: 'success'
                                , autoHideDelay: 1250
                            }
                        );
                    }
                    Vue.nextTick(() => {this.pendingChanges = false;});
                })
                .catch( error => {
                    this.queryInProgress = false;
					console.dir(error);
                    this.$bvToast.toast(
                        "Daten konnten nicht geladen werden."
                        , {
                            title: "Shipping Fee Rule Editor"
                            , appendToast: false
                            , variant: 'danger'
                            , noAutoHide: true
                        }
                    );
				});
            },
            save()
            {
                this.queryInProgress = true;
                for(let item of this.items)
                {
                    //what the fuck si this?
                    if(typeof item.fixedRate.replace === 'function') item.fixedRate = item.fixedRate.replace(',', '.');
                    if(typeof item.perKilo.replace   === 'function') item.perKilo   = item.perKilo.replace(',', '.');
                    if(typeof item.rfid.replace      === 'function') item.rfid      = item.rfid.replace(',', '.');

                    if(item.mdFlagNotSet == "")    item.mdFlagNotSet = 0;
                    if(item.mdFlagSet == "")       item.mdFlagSet = 0;
                    if(item.fixedRate == "")       item.fixedRate = 0;
                    if(item.perKilo == "")         item.perKilo = 0;
                    if(item.rfid == "")            item.rfid = 0;
                    if(item.useVolumeWeight == "") item.useVolumeWeight = 0;
                }

                axios.post('/shippingfeerule', this.items).then( response => {
                    this.alertSaveSwitch = true;
                    this.loadItems();
                    this.$bvToast.toast(
                        "Speichern erfolgreich."
                        , {
                            title: "Shipping Fee Rule Editor"
                            , appendToast: false
                            , variant: 'success'
                            , autoHideDelay: 1250
                        }
                    );
                }).catch(error => {
                    this.queryInProgress = false;
                    console.error(error);
                    this.$bvToast.toast(
                        'Änderungen wurden aufgrund eines Fehlers nicht gespeichert. Drücken Sie "Speichern" um es erneut zu versuchen.'
                        , {
                            title: "Shipping Fee Rule Editor"
                            , appendToast: false
                            , variant: 'danger'
                            , noAutoHide: true
                        }
                    );
                });
            },
            deleteItem(idx) {
                if(confirm('Wirklich löschen?'))
                {
                    if(this.items[idx].id == null)
                    {
                        this.items.splice(idx, 1);
                    }
                    else
                    {
                        this.queryInProgress = true;
                        axios.delete('/shippingfeerule/' + this.items[idx].id).then( response => {
                            this.items.splice(idx, 1);
                            this.queryInProgress = false;
                            this.$bvToast.toast(
                                "Löschvorgang erfolgreich."
                                , {
                                    title: "Shipping Fee Rule Editor"
                                    , appendToast: false
                                    , variant: 'success'
                                    , autoHideDelay: 1250
                                }
                            );

                        }).catch( error => {
                            this.queryInProgress = false;
                            this.$bvToast.toast(
                                "Löschvorgang fehlgeschlagen."
                                , {
                                    title: "Shipping Fee Rule Editor"
                                    , appendToast: false
                                    , variant: 'danger'
                                    , noAutoHide: true
                                }
                            );
                            console.log(error);
                        });
                    }
                }
            },
            createItem()
            {
                this.items.push({ id: null, 'name':'Regel', 'countryId':document.getElementById('selectCountry').value, 'sort':this.nextSortValue, 'upToWeight':'', 'fixedRate':0, 'perKilo':0, 'rfid':0, 'useVolumeWeight':0, 'mdFlagNotSet':0 , 'mdFlagSet':0});
                this.nextSortValue++;
            }
        },
        mounted() {
            this.loadItems(this.selectedCountry);
        }
    }
</script>
